export default "__VITE_ASSET__a0da88b4__"